import type { BadgeTone } from '@/app/components/ui/Badge';
import type { PilotStatus } from '@/features/pilots/types';

/** Draft/review phases are neutral, active work is mint, scaled is the
 * "succeeded" outcome — also mint (there is no separate "success" tone in
 * this system; see *Ontwerpreferentie*, zwart/wit/groen). */
export function statusTone(status: PilotStatus): BadgeTone {
  if (status === 'scaled') return 'mint';
  if (status === 'active') return 'mint';
  return 'outline';
}
